import axios from "../config/axios";
import Constants from "../data/Constants";

export const updateGlobal = async (data, pagination = {}) => {
  return await axios
    .put(Constants.ENDPOINTS.GLOBAL.UPDATE, data)
    .then((res) => {
      return res.data.result;
    }).catch((err) => {
      console.log(err);
    });
};

export const getGlobal = async (id, pagination = {}) => {
  return await axios.get(Constants.ENDPOINTS.GLOBAL.GET).then((res) => {
    return res.data.result;
  });
};
